export default {
  INCREMENT: 'INCREMENT',
  DECREMENT: 'DECREMENT',
  TRANSFER_ALL: 'TRANSFER_ALL',
  RECLASSIFICATION: 'RECLASSIFICATION',
  ENTIRE_CLASS_RECLASSIFICATION: 'ENTIRE_CLASS_RECLASSIFICATION',
  SPLIT: 'SPLIT',
};
